export const dbTabs2 = {
  ageRules: {
    heading: "قواعد النزلاء",
    headHint:
      "حدِّد مَن يُعَدّ رضيعًا أو طفلًا أو بالغًا وكيف يُحتسَبون ضمن السعة {scope}. افتراضيًا، لا يشغل الرُّضَّع مكانًا ولا تُفرَض عليهم رسوم.",
    scopeHotel: "لكل غرفة",
    scopeApartment: "لمكان الإقامة",
    loading: "جارٍ تحميل القواعد…",
    emptyHotel: "لا توجد غرف مُهيَّأة في هذا الفندق.",
    capacityChipTitle: "سعة الغرفة (تُحدَّد في السعة)",
    slots: "{count} مكان | {count} أماكن",
    badgeCustom: "مخصّصة",
    badgeStandard: "قياسية",
    applyAgeRules: "تطبيق قواعد العمر",
    masterSubHotel: "رُضَّع وأطفال وسعة مخصّصة في هذه الغرفة.",
    masterSubApartment: "رُضَّع وأطفال وسعة مخصّصة في مكان الإقامة هذا.",
    standardNote:
      "السلوك القياسي: لا يُحتسَب الرُّضَّع ضمن السعة ولا تُفرَض عليهم رسوم.",
    capacityLabel: "السعة",
    capacityGuestsNote:
      'نزيل · تُحدَّد في "السعة"؛ هذه القواعد تضبط فقط مَن يُحتسَب | نزلاء · تُحدَّد في "السعة"؛ هذه القواعد تضبط فقط مَن يُحتسَب',
    infantUpTo: "الرُّضَّع حتى سن",
    years: "سنة",
    childToAdult: "يصبح الطفل بالغًا عند سن",
    maxInfants: "الحد الأقصى للرُّضَّع",
    perBooking: "لكل حجز",
    infantsOccupy: "الرُّضَّع يشغلون مكانًا",
    infantsCharged: "تُفرَض رسوم على الرُّضَّع",
    childrenCount: "يُحتسَب الأطفال كنزلاء",
    ageLegend:
      "رضيع: أقل من {infant} سنة · طفل: {infant}–{childTo} سنة · بالغ: {adult}+ سنة.",
    listingCapacity: "سعة الإعلان",
    listingCapacityHint: 'تُحدَّد في "السعة" وتُشارَك مع "الإشغال".',
    thisAccommodation: "مكان الإقامة هذا",
    loadError: "تعذّر تحميل قواعد النزلاء.",
    saveSuccess: "تم حفظ قواعد النزلاء بنجاح.",
    saveError: "تعذّر حفظ قواعد النزلاء.",
  },
  globalPayments: {
    title: "المدفوعات العامة (الشقق/الفلل)",
    pill: "عام",
    desc: "ينطبق هذا الإعداد على جميع عقارات المستخدم من نوع شقة/فيلا.",
    loading: "جارٍ تحميل الإعداد…",
    paymentType: "نوع الدفع",
    onArrivalLabel: "الدفع عند الوصول",
    onArrivalDesc: "يحجز النزيل ويدفع مباشرةً عند الوصول.",
    onlineLabel: "الدفع عبر الإنترنت",
    onlineDesc: "يدفع النزيل عبر الإنترنت عند إتمام الحجز.",
    savedAtUserLevel: "يُحفَظ على مستوى المستخدم للشقق/الفلل.",
    globalDiscount: "خصم عام",
    enableGlobalDiscount: "تفعيل الخصم العام",
    discountType: "نوع الخصم",
    percentageLabel: "نسبة مئوية",
    percentageDesc: "خصم متناسب مع الإجمالي.",
    fixedLabel: "ثابت",
    fixedDesc: "مبلغ ثابت يُخصَم.",
    valueTitle: "القيمة",
    phPercentage: "مثال: 10",
    phFixed: "مثال: 15.00",
    helpPercentage: "بحد أقصى 100%. يُطبَّق على الإجمالي.",
    helpFixed: "يُخصَم مبلغ ثابت بعملة {currency}.",
    previewTitle: "معاينة",
    previewPercentage: "سيُطبَّق خصم عام بنسبة {percent}%.",
    previewFixed: "سيُطبَّق خصم عام بقيمة {amount}.",
    appliesAllDirect: "ينطبق على جميع الحجوزات المباشرة للشقق/الفلل.",
    saveSuccess: "تم حفظ المدفوعات العامة.",
    saveError: "تعذّر حفظ المدفوعات العامة.",
  },
  payments: {
    loading: "جارٍ تحميل الإعداد…",
    q02Title: "متى يدفع النزيل؟",
    savingBadge: "جارٍ الحفظ…",
    payOnArrivalName: "الدفع عند الوصول",
    payOnArrivalHint: "يحجز النزيل ويدفع مباشرةً عند الوصول.",
    payOnlineName: "الدفع عبر الإنترنت",
    payOnlineHint: "يدفع النزيل عبر الإنترنت عند إتمام الحجز.",
    q03Title: "مهلة الدفع",
    onlineOnlyBadge: "الدفع عبر الإنترنت فقط",
    holdDesc:
      "يُقفَل التقويم بينما يُتِمّ النزيل الدفع.<br>إذا لم يدفع خلال المدة المحددة، <strong>تُحرَّر الإتاحة تلقائيًا</strong>.",
    unitMin: "دقيقة",
    unitHour: "ساعة",
    unitHours: "ساعات",
    q04Title: "الدفع الجزئي",
    partialTitle: "السماح بدفع جزء فقط عند الحجز",
    partialOnDesc:
      "<strong>مُفعّل.</strong> يمكن للنزيل دفع <strong>{percent}%</strong> الآن والباقي قبل الوصول (أو الدفع بالكامل).",
    partialOffDesc:
      "<strong>مُعطّل.</strong> يدفع النزيل <strong>المبلغ الكامل</strong> عند الحجز.",
    blockTitle: "يُدفَع الباقي في مكان الإقامة",
    blockOnDesc:
      "<strong>مُفعّل.</strong> يدفع النزيل <strong>{percent}% فقط</strong> عبر الإنترنت؛ ويُسدِّد الباقي <strong>عند الوصول</strong> (لا يمكنه الدفع بالكامل عبر الإنترنت).",
    blockOffDesc:
      "<strong>مُعطّل.</strong> يمكن للنزيل اختيار دفع {percent}% أو المبلغ الكامل عبر الإنترنت.",
    q05Title: "تذكير بالرصيد",
    reminderTitle: "إرسال تذكير بدفع الرصيد المتبقّي",
    reminderOnDesc:
      "<strong>مُفعّل.</strong> <strong>{when}</strong> من الوصول (حوالي الساعة 09:00 بتوقيت العقار) يُرسَل إلى النزيل رابط لدفع الرصيد المتبقّي عبر <strong>واتساب والبريد الإلكتروني</strong>.",
    reminderOffDesc:
      "<strong>مُعطّل.</strong> لا يتلقّى النزيل تذكيرًا لدفع الرصيد عبر الإنترنت قبل الوصول.",
    daysBefore: "قبل {count} يوم | قبل {count} أيام",
    reminderDaysLabel: "الأيام قبل الوصول",
    reminderHint:
      "يُرسَل مرة واحدة فقط، وفقط للنزلاء الذين لديهم رصيد متبقٍّ. إذا كان الباقي يُدفَع في مكان الإقامة، فلا يُرسَل.",
    approveTitle: "الموافقة على الحجوزات",
    approveCardTitle: "الموافقة على كل حجز قبل تأكيده",
    approveOnDesc:
      "<strong>مُفعّل.</strong> يبقى كل حجز <strong>بانتظار موافقتك</strong>: يصلك إشعار وتقرّر قبوله أو رفضه. ولا يُؤكَّد حتى توافق عليه.",
    approveOffDesc:
      "<strong>مُعطّل.</strong> تُؤكَّد الحجوزات <strong>تلقائيًا</strong> بمجرد إتمام الدفع. فعِّله إذا كنت تفضّل مراجعة كل طلب والموافقة عليه بنفسك.",
    saveSuccess: "تم الحفظ.",
    saveError: "تعذّر حفظ التغييرات.",
  },
  unitConfig: {
    descByRoom: "وصف لكل غرفة",
    descByRoomHint:
      "لكل غرفة وصفها الخاص ومدى ظهورها في الحجز المباشر.",
    loadingRooms: "جارٍ تحميل الغرف…",
    emptyHotel: "لا توجد غرف مُهيَّأة في هذا الفندق.",
    visible: "ظاهر",
    hidden: "مخفي",
    roomDescPlaceholder: "صِف {name} (الأسرّة، وسائل الراحة، الإطلالات…)",
    savingDesc: "جارٍ الحفظ…",
    autosaveHint: "يُحفَظ تلقائيًا عند مغادرة الحقل.",
    loadingProperty: "جارٍ تحميل بيانات مكان الإقامة…",
    loadErrorProperty: "تعذّر تحميل إعدادات مكان الإقامة هذا.",
    amenitiesByRoom: "وسائل الراحة لكل غرفة",
    amenitiesByRoomHint:
      "يمكن لكل غرفة تقديم وسائل راحة مختلفة. يستخدم الحجز المباشر ووكيل الذكاء الاصطناعي وسائل راحة الغرفة المخصّصة للنزيل.",
    amenitiesCount: "{count} وسيلة راحة | {count} وسائل راحة",
    noAmenities: "بلا وسائل راحة",
    titleDescription: "وصف مكان الإقامة",
    titleServices: "التجهيزات ووسائل الراحة",
    subtitleDescription:
      "حرِّر الوصف الذي سيراه النزلاء في صفحة الحجز المباشر.",
    subtitleServices: "حدّد ما يقدمه هذا السكن وارفع صوره.",
  },
};
